import React__default from 'react';
import CentralizedModal from '../CentralizedModal/index.js';
import Button from '../Button/index.js';
var ConfirmationModal = function ConfirmationModal(_ref) {
  var title = _ref.title,
    text = _ref.text,
    isActive = _ref.isActive,
    handleDangerButton = _ref.handleDangerButton,
    handleButton = _ref.handleButton,
    handleCloseModal = _ref.handleCloseModal,
    dangerButtonText = _ref.dangerButtonText,
    buttonText = _ref.buttonText,
    _ref$hasOverlay = _ref.hasOverlay,
    hasOverlay = _ref$hasOverlay === void 0 ? true : _ref$hasOverlay,
    _ref$hasCloseButton = _ref.hasCloseButton,
    hasCloseButton = _ref$hasCloseButton === void 0 ? true : _ref$hasCloseButton;
  return /* @__PURE__ */React__default.createElement(CentralizedModal, {
    customClass: "iq-confirmation-modal",
    isActive: isActive,
    hasCloseButton: hasCloseButton,
    hasOverlay: hasOverlay,
    handleCloseModal: handleCloseModal
  }, /* @__PURE__ */React__default.createElement("div", {
    className: "iq-confirmation-modal__content"
  }, /* @__PURE__ */React__default.createElement("div", {
    className: "iq-confirmation-modal__content-top"
  }, title && /* @__PURE__ */React__default.createElement("h2", {
    className: "iq-confirmation-modal__title"
  }, title), text && /* @__PURE__ */React__default.createElement("p", {
    className: "iq-confirmation-modal__text"
  }, text)), /* @__PURE__ */React__default.createElement("div", {
    className: "iq-confirmation-modal__bottom"
  }, /* @__PURE__ */React__default.createElement(Button, {
    type: "secondary",
    color: "danger",
    "aria-label": dangerButtonText,
    onClick: handleDangerButton
  }, dangerButtonText), /* @__PURE__ */React__default.createElement(Button, {
    "aria-label": buttonText,
    onClick: handleButton
  }, buttonText))));
};
export { ConfirmationModal as default };